module.exports = __webpack_public_path__ + "static/media/metronome.065f8708.png";